import { z } from 'zod';

export const SambaNativeRuntimeSchema = z.object({
    platform: z.union([z.literal('win'), z.literal('mac'), z.literal('other')]),
    arch: z.union([z.literal('x64'), z.literal('arm64'), z.literal('other')]),
});

export type SambaNativeRuntime = z.infer<typeof SambaNativeRuntimeSchema>;

const SambaRuntimeGlobalSchema = z.object({
    sambaWebsiteApi: z
        .object({
            nativeRuntime: SambaNativeRuntimeSchema.optional(),
            completePortalLogout: z.function({ input: [], output: z.promise(z.void()) }).optional(),
        })
        .optional(),
});

export function getSambaNativeRuntime(): SambaNativeRuntime | null {
    const parsedGlobal = SambaRuntimeGlobalSchema.safeParse(globalThis);
    if (!parsedGlobal.success) {
        return null;
    }
    return parsedGlobal.data.sambaWebsiteApi?.nativeRuntime ?? null;
}

export async function completeSambaPortalLogout(): Promise<void> {
    const parsedGlobal = SambaRuntimeGlobalSchema.safeParse(globalThis);
    if (!parsedGlobal.success) {
        throw new Error(
            'The native Logout interface is invalid. Relaunch Anchorbase and try again.'
        );
    }
    const api = parsedGlobal.data.sambaWebsiteApi;
    if (api?.nativeRuntime === undefined) {
        return;
    }
    // The acknowledgement is additive to the incumbent native interface.
    // Older runtimes retain their cookie-driven Logout lifecycle.
    await api.completePortalLogout?.();
}
